import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  clearBaggageExcesses,
  getSalesSessionBaggageExcesses,
} from '../../../../actions';
import { SALES_SESSION_BAGGAGE_EXCESSES_COLUMNS } from '../../../../config/columns';
import Table from '../../../common/Table';
import { filterMethodCaseInsensitive } from '../../../../utils/filter-methods';
import { BAGGAGE_PATH } from '../../../../config/paths';

const ExcessBaggageTable = ({
  salesSessionId,
  loading,
  salesSessionBaggageExcesses,
  dispatchGetSalesSessionBaggageExcesses,
  dispatchClearBaggageExcesses,
}) => {
  useEffect(() => {
    dispatchGetSalesSessionBaggageExcesses({ salesSessionId });

    return () => {
      dispatchClearBaggageExcesses();
    };
  }, [
    salesSessionId,
    dispatchGetSalesSessionBaggageExcesses,
    dispatchClearBaggageExcesses,
  ]);

  return (
    <>
      <Table
        manual={false}
        columns={SALES_SESSION_BAGGAGE_EXCESSES_COLUMNS}
        data={salesSessionBaggageExcesses}
        loading={loading}
        filterable
        defaultFilterMethod={filterMethodCaseInsensitive}
        navigateToModelOnRowClick
        openPathInNewTab
        modelPath={BAGGAGE_PATH}
        modelId="baggageId"
      />
      <br />
    </>
  );
};

ExcessBaggageTable.propTypes = {
  salesSessionId: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchGetSalesSessionBaggageExcesses: PropTypes.func.isRequired,
  dispatchClearBaggageExcesses: PropTypes.func.isRequired,
  salesSessionBaggageExcesses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      documentSeries: PropTypes.string.isRequired,
      documentCode: PropTypes.number.isRequired,
      weight: PropTypes.number.isRequired,
      priceBeforeDiscount: PropTypes.number.isRequired,
      discountAmount: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
      paymentMethod: PropTypes.string.isRequired,
    }),
  ),
};

ExcessBaggageTable.defaultProps = {
  salesSessionBaggageExcesses: [],
};

const mapStateToProps = ({ BaggageUnit }) => ({
  loading: BaggageUnit.Baggage.getIn(['excess', 'loading']),
  salesSessionBaggageExcesses: BaggageUnit.Baggage.getIn([
    'excess',
    'content',
  ]).toJS(),
});

const mapDispatchToProps = {
  dispatchGetSalesSessionBaggageExcesses: getSalesSessionBaggageExcesses,
  dispatchClearBaggageExcesses: clearBaggageExcesses,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExcessBaggageTable);
